module.exports = __webpack_public_path__ + "img/image_1.522d0ce0.jpg";